import CitySEO from "./components/CitySEO";
import CityHeroSection from "./components/CityHeroSection";
import CityStickyNav from "./components/CityStickyNav";
import CityProcessingTimeSection from "./components/CityProcessingTimeSection";
import CityServicesSection from "./components/CityServicesSection";
import CityLocalAreaSection from "./components/CityLocalAreaSection";
import CityTestimonialsSection from "./components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "./components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "./components/CityComparisonSection";
import CityMistakesSection from "./components/CityMistakesSection";
import CityHowItWorksSection from "./components/CityHowItWorksSection";
import CityFAQSection from "./components/CityFAQSection";
import CityHelpfulResourcesSection from "./components/CityHelpfulResourcesSection";
import CityFinalCTA from "./components/CityFinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import CityTravelTimingSection from "./components/CityTravelTimingSection";
import CityDestinationsSection from "./components/CityDestinationsSection";
import type { CityConfig } from "./types";

export default function CityPageTemplate({ config }: { config: CityConfig }) {
  return (
    <div className="font-sans">
      <CitySEO config={config} />
      <CityHeroSection
        city={config.city}
        h1={config.h1}
        subtitle={config.heroSubtitle}
        imageUrl={config.heroImageUrl}
        imageAlt={config.heroImageAlt}
      />
      <CityStickyNav links={config.stickyNavLinks} />
      <CityProcessingTimeSection city={config.city} state={config.stateAbbr} options={config.processingOptions} intro={config.processingIntro} />
      <CityServicesSection city={config.city} services={config.services} intro={config.servicesIntro} />
      <CityLocalAreaSection
        city={config.city}
        state={config.state}
        cities={config.nearbyCitiesZips}
        benefits={config.benefits}
        internalLinks={config.internalLinks}
        officeNote={config.fpcOfficeNote}
        officeDistance={config.fpcOfficeDistance}
        officeAddress={config.fpcOfficeAddress}
        serviceAreaIntro={config.serviceAreaIntro}
        nearbyCitiesIntro={config.nearbyCitiesIntro}
        localAreaIntro={config.localAreaIntro}
      />
      <CityTestimonialsSection city={config.city} testimonials={config.testimonials.slice(0, 3)} intro={config.testimonialsIntro} />
      <CityAcceptanceFacilitiesSection city={config.city} facilities={config.facilities} />
      <CityComparisonSection city={config.city} regionalAgency={config.regionalAgency} rows={config.comparisonRows} extraColumns={config.comparisonExtraColumns} />
      <CityMistakesSection city={config.city} mistakes={config.mistakes} intro={config.mistakesIntro} />
      <CityHowItWorksSection city={config.city} steps={config.steps} intro={config.howItWorksIntro} />
      <CityFAQSection city={config.city} faqs={config.faqs} intro={config.faqIntro} />
      {config.travelTiming && (
        <CityTravelTimingSection city={config.city} data={config.travelTiming} />
      )}
      {config.destinations && (
        <CityDestinationsSection city={config.city} data={config.destinations} />
      )}
      <CityHelpfulResourcesSection
        city={config.city}
        state={config.state}
        photoLocations={config.photoLocations}
        dmvLocations={config.dmvLocations}
        airports={config.airports}
        dmvWebsite={config.dmvWebsite}
        dmvLabel={config.dmvLabel}
        vitalRecordsLinks={config.vitalRecordsLinks}
      />
      <SEOCrossLinks currentRoute={config.route} state={config.stateAbbr} showCities={true} />
      <CityFinalCTA />
    </div>
  );
}